module.exports = __webpack_public_path__ + "static/media/Cottonv4.0.4dd68399.PNG";